class FileUploadSource {
  private _sourceType: string;
  private _environment: 'BROWSER' | 'OS'; //업로드 할 때, '웹 페이지'에서 등록하는가 /아니면/ '시스템'에서 등록하는가 여부를 파악한다
  private _browserDatas: File[];
  private _osFilePaths: string[];

  public constructor(sourceType: string = '') {
    this._sourceType = sourceType;
    this._environment =
      typeof window !== 'undefined' && window.sessionStorage !== null
        ? 'BROWSER'
        : 'OS';
    this._browserDatas = [];
    this._osFilePaths = [];
  }

  public get sourceType(): string {
    return this._sourceType;
  }

  public get environment(): 'BROWSER' | 'OS' {
    return this._environment;
  }

  public get browserDatas(): File[] {
    return this._browserDatas;
  }

  public get osFilePaths(): string[] {
    return this._osFilePaths;
  }

  public addFilePath(filePath: string): void {
    if (this._environment === 'BROWSER') {
      throw 'You cannot adding upload target to this when you run on Browser';
    }

    this._osFilePaths.push(filePath);
  }

  public addBrowserData(inputFile: File) {
    if (this._environment == 'OS') {
      throw 'You cannot adding upload target to this when you run on OS';
    }

    this._browserDatas.push(inputFile);
  }

  public clear(): void {
    this._browserDatas.splice(0, this._browserDatas.length);
    this._osFilePaths.splice(0, this._osFilePaths.length);
  }
}

class FileDeleteSource {
  private _targets: string[];

  constructor() {
    this._targets = [];
  }

  public add(fileId: string): void {
    this._targets.push(fileId);
  }

  public clear(): void {
    this._targets.splice(0, this._targets.length);
  }

  public get items(): string[] {
    return this._targets;
  }
}

class FileTransferSource {
  private _uploadSource: FileUploadSource | null;
  private _deleteSource: FileDeleteSource | null;

  public constructor(
    uploadSource: FileUploadSource | null = null,
    deleteSource: FileDeleteSource | null = null
  ) {
    this._uploadSource = uploadSource;
    this._deleteSource = deleteSource;
  }

  public get uploadSource(): FileUploadSource | null {
    return this._uploadSource;
  }

  public get deleteSource(): FileDeleteSource | null {
    return this._deleteSource;
  }

  public set uploadSource(uploadSource: FileUploadSource | null) {
    this._uploadSource = uploadSource;
  }

  public set deleteSource(deleteSource: FileDeleteSource | null) {
    this._deleteSource = deleteSource;
  }
}

interface FileTransferProgress {
  state: 'Preparing' | 'Uploading' | 'Deleting' | 'Completed';
  fileName: string;
  progressRate?: number | undefined;
  totalFileSize?: number | undefined;
  transferred?: number | undefined;
  remainingTime?: number | undefined;
}

interface FileTransferResult {
  upload: FileUploadResult[] | null;
  delete: FileDeleteResult[] | null;
}

interface FileTransferError {
  reason: string;
}

interface FileUploadResult {
  fileId: string;
  filePath?: string | undefined;
  fileName: string;
  fileSize: number;
  uri?: string | undefined;
  transferResult: 'succeed' | 'failed';
  error?: FileTransferError | undefined;
}

interface FileDeleteResult {
  fileId: string;
  transferResult: 'succeed' | 'failed';
  error?: FileTransferError;
}

// --- Batch Download ---
interface BatchDownloadRequest {
  resourceIds: string[];
  zipFileName?: string;
}

enum BatchDownloadState {
  ACCEPTED = 'ACCEPTED',
  STARTED = 'STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

interface BatchDownloadProgress {
  requestId: string;
  state: BatchDownloadState;
}

enum BatchDownloadErrorCode {
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  ZIP_CREATION_FAILED = 'ZIP_CREATION_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

interface BatchDownloadResult {
  requestId: string;
  state: BatchDownloadState;
  fileCount: number;
  totalFileSize: number;
  zipFileUri: string;
  errorCode?: BatchDownloadErrorCode;
}

export {
  FileUploadSource,
  FileDeleteSource,
  FileTransferSource,
  BatchDownloadState,
  BatchDownloadErrorCode,
};
export type {
  FileTransferProgress,
  FileTransferResult,
  FileTransferError,
  FileUploadResult,
  FileDeleteResult,
  BatchDownloadRequest,
  BatchDownloadProgress,
  BatchDownloadResult,
};
